/**
 * Wall-clock timestamp for console diagnostics: `HH:MM:SS.mmm` (local time, 24h). Every diag family
 * ([cqg-relay], [positions], [cqg-dialog], …) prepends this so a pasted console trace can be lined up
 * against BE CloudWatch timestamps without guessing (the 2026-07-07 live-positions debug needed exactly
 * that correlation and the console had no times at all).
 */
export function ts(): string {
  const d = new Date();
  const p2 = (n: number) => String(n).padStart(2, '0');
  return `${p2(d.getHours())}:${p2(d.getMinutes())}:${p2(d.getSeconds())}.${String(d.getMilliseconds()).padStart(3, '0')}`;
}
